import { useDispatch, useSelector } from 'react-redux';
import Trans from '@/components/shared/Trans';
import translations from '../FilterBar.trans.json';
import { formatSelectedText } from '../utils';
import { RANGE_DATE } from '../constants/filtersConstants';
import { setSelectedIds } from '@/store/slices/components/filterBar/FilterBarSlice';
import { useFilterSelection } from '../FilterSelectControl';
import RangeDateDropdownControlled from './RangeDateDropdownControlled';

/**
 * Redux-backed date-range filter for Dashboard / Leads FilterBar.
 * Assignment Report uses RangeDateDropdownControlled directly.
 */
function RangeDateDropdown({ deleteRangeDate = true }) {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const currentSelection = selectedIds.find(
    (item) => item.filter_type === RANGE_DATE
  );
  const rangeDateTitle = Trans(translations, 'filterBarLeads.CreationDate');
  const selection = useFilterSelection(RANGE_DATE, {
    clearable: deleteRangeDate,
  });

  const applySelection = (next) => {
    dispatch(
      setSelectedIds({
        idList: [
          {
            ...next,
            filter_type: RANGE_DATE,
            dontRemove: !deleteRangeDate,
          },
        ],
        type: RANGE_DATE,
      })
    );
  };

  return (
    <RangeDateDropdownControlled
      value={currentSelection}
      onChange={applySelection}
      title={rangeDateTitle}
      buttonText={formatSelectedText(selectedIds, rangeDateTitle, RANGE_DATE)}
      filled={selection.filled}
      selection={selection}
    />
  );
}

export default RangeDateDropdown;
